'use client'

/**
 * Loading Spinner Component
 * Displays a terminal-style loading animation
 *
 * Usage:
 * <LoadingSpinner />
 * <LoadingSpinner message="> loading data..." />
 * <LoadingSpinner size="small" />
 */

export default function LoadingSpinner({ message = '> initializing process...', size = 'medium' }) {
  return (
    <div className="sc-loading">
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <span className="sc-loading-text">{message}</span>
        <span className="sc-loading-cursor"></span>
      </div>
    </div>
  )
}
